<script setup lang="ts">
import { type Color } from '@global-types/colors';
import { type Subset } from '@global-types/utilities';

type DividerColor = Subset<Color, 'gray' | 'black-lighter'>;

const { color = 'gray' } = defineProps<{ color?: DividerColor}>();
</script>

<template>
  <hr
    class="divider"
    :class="`divider--color-${color}`"
  >
</template>
